//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {NsModal} from '@nuskin/design-components';

export default {
  name: 'PromoteAppModal',
  components: {NsModal},
  props: {},
  data() {
    return {
      showVeraModal: false
    };
  },
  computed: {
    veraImg() {
      if (this.veraAdHasAllNecessaryData) {
        const derivatives = this.$t('promoteApps.vera.logo[0].derivatives');
        if (derivatives.thumbnail) {
          return derivatives.thumbnail;
        } else if (derivatives.mini) {
          return derivatives.mini;
        } else if (derivatives.small) {
          return derivatives.small;
        } else if (derivatives.webImage) {
          return derivatives.webImage;
        } else if (derivatives.original) {
          return derivatives.original;
        }
      }
      return null;
    },
    veraAdHasAllNecessaryData() {
      const isVeraTitle = !['promoteApps.vera.title', ''].includes(
        this.$t('promoteApps.vera.title')
      );
      const isVeraLogo = !['promoteApps.vera.logo[0].derivatives', ''].includes(
        this.$t('promoteApps.vera.logo[0].derivatives')
      );
      const isVeraBodyText = !['promoteApps.vera.bodyText', ''].includes(
        this.$t('promoteApps.vera.bodyText')
      );
      const isVeraButtonText = !['promoteApps.vera.buttonText', ''].includes(
        this.$t('promoteApps.vera.buttonText')
      );
      const isVeraButtonUrl = !['promoteApps.vera.buttonUrl', ''].includes(
        this.$t('promoteApps.vera.buttonUrl')
      );
      const isVeraDelay = !['promoteApps.vera.delay', ''].includes(
        this.$t('promoteApps.vera.delay')
      );
      const isHdePromoteVeraStorageItem = ![
        'promoteApps.vera.hidePromoteVeraStorageItem',
        ''
      ].includes(this.$t('promoteApps.vera.hidePromoteVeraStorageItem'));
      const isPromoteVeraIsActive =
        !['promoteApps.vera.promoteVeraIsActive', ''].includes(
          this.$t('promoteApps.vera.promoteVeraIsActive')
        ) && this.$t('promoteApps.vera.promoteVeraIsActive') === 'true';
      return (
        isVeraTitle &&
        isVeraLogo &&
        isVeraBodyText &&
        isVeraButtonText &&
        isVeraButtonUrl &&
        isVeraDelay &&
        isHdePromoteVeraStorageItem &&
        isPromoteVeraIsActive
      );
    }
  },
  mounted() {
    this.setUpVeraAd();
  },
  methods: {
    veraAdClose(setStorageItem) {
      if (setStorageItem) {
        localStorage.setItem(
          this.$t('promoteApps.vera.hidePromoteVeraStorageItem'),
          true
        );
      }
      this.setVeraShow(false);
    },
    veraAdOpen() {
      this.setVeraShow(true);
    },
    setVeraShow(state) {
      this.showVeraModal = state;
    },
    setUpVeraAd() {
      if (!this.veraAdHasAllNecessaryData) {
        return;
      }
      const delay = this.$t('promoteApps.vera.delay');
      const promoteVeraIsActive =
        this.$t('promoteApps.vera.promoteVeraIsActive') === 'true';
      const veraStorageItem = localStorage.getItem(
        this.$t('promoteApps.vera.hidePromoteVeraStorageItem')
      );
      setTimeout(() => {
        if (veraStorageItem) {
          return;
        }
        if (promoteVeraIsActive) {
          window.scrollBy(0, 100); // stop header from hiding top of modal
          this.veraAdOpen();
        }
      }, delay * 1000);
    },
    handleVeraButtonClick() {
      const url =
        window.location.origin + this.$t('promoteApps.vera.buttonUrl');
      window.open(url, '_blank');
      this.veraAdClose();
    }
  }
};
